import { BarChart2, Send, ToggleLeft, ToggleRight } from 'lucide-react';

const FG = '#F5F1FA';
const MUTED = '#A99FB8';
const SURFACE2 = '#140C20';
const SURFACE = '#1B1029';
const VIOLET = '#6D28D9';
const VIOLET_LIGHT = '#A855F7';
const CHAMPAGNE = '#E8B96A';
const CHAMPAGNE_LIGHT = '#F0C674';
const BORDER = 'rgba(255,255,255,0.08)';
const GREEN = '#4ADE80';

// Dados do mini grafico de barras (ultimos 6 meses)
const MESES = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun'];
const VALORES = [18, 24, 21, 28, 26, 31]; // movimentacoes por mes
const MAX_VAL = 35;

const METRICAS = [
  { label: 'Processos ativos', value: '96', color: FG },
  { label: 'Movimentações no mês', value: '42', color: VIOLET_LIGHT },
  { label: 'Prazos cumpridos', value: '100%', color: GREEN },
];

export function RelatoriosMockup() {
  return (
    <div
      style={{
        width: '100%',
        borderRadius: 16,
        overflow: 'hidden',
        border: `1px solid ${BORDER}`,
        background: SURFACE2,
        boxShadow:
          '0 0 0 1px rgba(109,40,217,0.15), 0 32px 80px rgba(0,0,0,0.55), 0 8px 24px rgba(109,40,217,0.12)',
        fontFamily: "'Hanken Grotesk', sans-serif",
      }}
    >
      {/* Titlebar */}
      <div
        style={{
          background: 'rgba(20,12,32,0.98)',
          borderBottom: `1px solid rgba(255,255,255,0.07)`,
          padding: '12px 18px',
          display: 'flex',
          alignItems: 'center',
          gap: 14,
        }}
      >
        <div style={{ display: 'flex', gap: 7, flexShrink: 0 }}>
          {['#FF5F56', '#FFBD2E', '#27C93F'].map((c) => (
            <span
              key={c}
              style={{
                width: 11,
                height: 11,
                borderRadius: '50%',
                background: c,
                opacity: 0.75,
                display: 'inline-block',
              }}
            />
          ))}
        </div>
        <BarChart2 size={13} color={VIOLET_LIGHT} strokeWidth={2} />
        <span style={{ fontSize: 12, fontWeight: 600, color: FG }}>Relatórios</span>
      </div>

      <style>{`
        @media (max-width: 600px) {
          .rel-metricas { grid-template-columns: 1fr 1fr !important; }
          .rel-card-header { flex-direction: column !important; align-items: flex-start !important; gap: 8px !important; }
        }
      `}</style>
      <div style={{ padding: '14px 14px 16px', display: 'flex', flexDirection: 'column', gap: 12 }}>
        {/* Card principal do relatorio */}
        <div
          style={{
            background: SURFACE,
            border: `1px solid ${BORDER}`,
            borderRadius: 12,
            padding: '14px 16px',
          }}
        >
          {/* Header do card */}
          <div
            className="rel-card-header"
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              marginBottom: 14,
            }}
          >
            <div>
              <p
                style={{
                  fontFamily: "'Fraunces', Georgia, serif",
                  fontSize: 14,
                  fontWeight: 400,
                  color: FG,
                  letterSpacing: '-0.01em',
                  margin: '0 0 4px',
                }}
              >
                Relatório mensal de andamento
              </p>
              <p style={{ fontSize: 10, color: MUTED, margin: 0 }}>Junho 2026 - Cassandra Advocacia</p>
            </div>
            <span
              style={{
                fontSize: 9,
                fontWeight: 700,
                letterSpacing: '0.1em',
                textTransform: 'uppercase' as const,
                color: VIOLET_LIGHT,
                background: 'rgba(168,85,247,0.1)',
                border: '1px solid rgba(168,85,247,0.22)',
                borderRadius: 5,
                padding: '3px 8px',
              }}
            >
              Personalizado
            </span>
          </div>

          {/* Mini grafico de linhas (SVG) */}
          <div
            style={{
              background: 'rgba(20,12,32,0.5)',
              border: `1px solid ${BORDER}`,
              borderRadius: 8,
              padding: '10px 12px 8px',
              marginBottom: 12,
            }}
          >
            <p
              style={{
                fontSize: 9,
                fontWeight: 700,
                letterSpacing: '0.1em',
                textTransform: 'uppercase' as const,
                color: MUTED,
                margin: '0 0 8px',
              }}
            >
              Movimentações por mês
            </p>
            {/* Barras simples */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: `repeat(${MESES.length}, 1fr)`,
                gap: 4,
                alignItems: 'flex-end',
                height: 44,
              }}
            >
              {MESES.map((mes, i) => {
                const isLast = i === MESES.length - 1;
                return (
                  <div
                    key={mes}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      gap: 3,
                      height: '100%',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <div
                      style={{
                        width: '100%',
                        maxWidth: 18,
                        height: `${(VALORES[i] / MAX_VAL) * 100}%`,
                        background: isLast
                          ? `linear-gradient(180deg, ${VIOLET_LIGHT} 0%, ${VIOLET} 100%)`
                          : 'rgba(168,85,247,0.28)',
                        borderRadius: '3px 3px 0 0',
                        position: 'relative',
                        overflow: 'hidden',
                      }}
                    >
                      {isLast && (
                        <div
                          style={{
                            position: 'absolute',
                            inset: 0,
                            background: `linear-gradient(180deg, rgba(255,255,255,0.15) 0%, transparent 50%)`,
                          }}
                        />
                      )}
                    </div>
                    <span
                      style={{
                        fontSize: 8,
                        color: isLast ? FG : MUTED,
                        fontWeight: isLast ? 600 : 400,
                      }}
                    >
                      {mes}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Metricas */}
          <div className="rel-metricas" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 8 }}>
            {METRICAS.map((m) => (
              <div
                key={m.label}
                style={{
                  background: 'rgba(20,12,32,0.5)',
                  border: `1px solid ${BORDER}`,
                  borderRadius: 8,
                  padding: '9px 10px',
                }}
              >
                <p style={{ fontSize: 8, color: MUTED, margin: '0 0 5px', fontWeight: 500 }}>
                  {m.label}
                </p>
                <p
                  style={{
                    fontFamily: "'Fraunces', Georgia, serif",
                    fontSize: 16,
                    fontWeight: 400,
                    color: m.color,
                    margin: 0,
                    letterSpacing: '-0.01em',
                    lineHeight: 1,
                  }}
                >
                  {m.value}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Painel envio automatico */}
        <div
          style={{
            background: `linear-gradient(135deg, rgba(109,40,217,0.12) 0%, rgba(20,12,32,0.6) 100%)`,
            border: `1px solid rgba(109,40,217,0.28)`,
            borderRadius: 12,
            padding: '13px 16px',
          }}
        >
          {/* Header do painel */}
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              marginBottom: 12,
            }}
          >
            <Send size={11} color={VIOLET_LIGHT} strokeWidth={2.5} />
            <span
              style={{
                fontSize: 9,
                fontWeight: 700,
                letterSpacing: '0.14em',
                textTransform: 'uppercase' as const,
                color: VIOLET_LIGHT,
              }}
            >
              Envio automático
            </span>
            <span
              style={{
                marginLeft: 'auto',
                fontSize: 8,
                fontWeight: 700,
                letterSpacing: '0.08em',
                textTransform: 'uppercase' as const,
                color: CHAMPAGNE_LIGHT,
                background: 'rgba(232,185,106,0.14)',
                border: `1px solid rgba(232,185,106,0.32)`,
                borderRadius: 4,
                padding: '2px 7px',
              }}
            >
              Programado
            </span>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {/* Agendamento */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <span style={{ fontSize: 9, color: MUTED, flexShrink: 0 }}>Periodicidade</span>
              <span
                style={{
                  fontSize: 9,
                  fontWeight: 700,
                  color: FG,
                  background: 'rgba(255,255,255,0.06)',
                  border: `1px solid rgba(255,255,255,0.1)`,
                  borderRadius: 5,
                  padding: '3px 9px',
                }}
              >
                Toda segunda, 08:00
              </span>
            </div>

            {/* Toggle destino */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 9, color: MUTED, flexShrink: 0 }}>Enviar para</span>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 2,
                  background: 'rgba(20,12,32,0.6)',
                  border: `1px solid rgba(255,255,255,0.1)`,
                  borderRadius: 6,
                  padding: '2px',
                }}
              >
                {['Cliente', 'Equipe'].map((opt, i) => (
                  <span
                    key={opt}
                    style={{
                      fontSize: 9,
                      fontWeight: 600,
                      padding: '3px 10px',
                      borderRadius: 5,
                      color: i === 0 ? FG : MUTED,
                      background: i === 0 ? VIOLET : 'transparent',
                      transition: 'background 0.15s ease',
                    }}
                  >
                    {opt}
                  </span>
                ))}
              </div>
            </div>

            {/* Chips de destinatario */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' as const }}>
              <span style={{ fontSize: 9, color: MUTED, flexShrink: 0 }}>Destinatários</span>
              {['cliente@exemplo.com', 'Equipe interna'].map((dest) => (
                <span
                  key={dest}
                  style={{
                    fontSize: 9,
                    fontWeight: 500,
                    color: CHAMPAGNE,
                    background: 'rgba(232,185,106,0.08)',
                    border: `1px solid rgba(232,185,106,0.22)`,
                    borderRadius: 5,
                    padding: '2px 8px',
                  }}
                >
                  {dest}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
